import VueRaven from 'vue-raven'
import Vue from 'vue'

if (process.env.NODE_ENV === 'production') {
    Vue.use(VueRaven, {
        dsn: 'https://b9b820e2b94f48a585d64b5d5a43995c@sentry.io/1313386'
    });
} else {
    console.log('=== Not initiating front-end sentry Raven client');
}
